import { LOCAL_STORAGE_RENTAL_PORTAL_OVERVIEW_PANELS_LAYOUT_KEY } from '../../../../constants/storage'
import { BirdviewLayout } from '../../../DashboardBirdview'

import { OVERVIEW_PANEL_DEFAULT_LAYOUT } from './RentalPortalOverviewPanels.constants'
import { useRentalPortalOverviewPanelWidgets } from './RentalPortalOverviewPanels.hooks'

function RentalPortalOverviewPanels({ isLoading, overview, onRetryPanel }) {
  const { overlayTitles, widgets } = useRentalPortalOverviewPanelWidgets({
    isLoading,
    overview,
    onRetryPanel,
  })

  return (
    <BirdviewLayout
      defaultLayout={OVERVIEW_PANEL_DEFAULT_LAYOUT}
      overlayTitles={overlayTitles}
      storageKeyPrefix={LOCAL_STORAGE_RENTAL_PORTAL_OVERVIEW_PANELS_LAYOUT_KEY}
      widgets={widgets}
    />
  )
}

export default RentalPortalOverviewPanels
